import React, {useCallback, useEffect, useRef, useState} from 'react';
import UButton from "ubs-framework/v2/UButton";
import UModal from "ubs-framework/v2/UModal/NewUModal";
import UInput from "ubs-framework/v2/UInput";
import UCheckBox from "ubs-framework/v2/UCheckBox";
import URadio from "ubs-framework/v2/URadio";
import UDatePicker from "ubs-framework/v2/UDatePicker";
import Validator from "simple-react-validator";
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import {useDispatch, useSelector} from "react-redux";
import { getKeyName, getLabelValue, getLabelValueUserImage, getThumbor, bytesToSize, Encryption, getExtension, getCookie } from "ubs-framework/v2/common/function";
import { searchInArray } from "../../../common/functions/common";
import useSocket from "../../common/hooks/useSocket";
import AsyncEmployeeSelect from "../../common/employee-access-select/async-employee-select";
import Select, {components} from "react-select";
import {api2, sendData} from "../../../store/actions";
import UTags from "ubs-framework/v2/UTags";
import UAvatar from "ubs-framework/v2/UAvatar";
import useUAlert from "ubs-framework/v2/UAlert";
import useDebouncedEffect from "use-debounced-effect";
import {COLOR, FILE, LIMIT, PROFILE_SECTION} from "ubs-framework/v2/common/constant";
import * as Icon from "ubs-icons";
import UPopup from "ubs-framework/v2/UPopup";
import CreatableSelect from "react-select/creatable/dist/react-select.esm";
import {useHistory} from "react-router-dom";
import UDateFormatter from "ubs-framework/v2/Udate-formatter";
import { useFieldLabel } from 'ubs-framework/v2/hooks/useCustomFieldConfig';

const AddQuickCandidate = React.memo((props) => {
    const alert = useUAlert();
    const dispatch = useDispatch();
    const getLabel = useFieldLabel();
    const history = useHistory();
    const _USERS = useSelector(e => e?.ats?.userObj || {});
    const _ORG_ID = useSelector(e => e.common.orgId);
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);
    const _SOCKET_ID = useSelector(e => e.common.socketId);
    const _A_LT = useSelector(e => getLabelValue(e?.hrms?.branchList));
    const _FSL = useSelector(e => e?.common?.settings?.maxFileSizeLimit);
    const _AS = useSelector(e => e?.ats?.uac?.settings?.modules);
    const _ASL = useSelector(e => getLabelValue(e?.ats?.atsSkillList));
    const _DC = useSelector(e => e?.ats?.generalSetting?.duplicateCriteria);
    const _AQC = useSelector(e => e?.candidate?.addQuickCandidate || {});
    const _TF_CL = useSelector(e => getLabelValue(e?.ats?.tagsForCandidateList));

    const [isLoading, setIsLoading] = useState(false);
    const [employeeListOption, setEmployeeListOption] = useState([]);
    const [loader, setLoader] = useState(false);
    const [uploadPercentage, setUploadPercentage] = useState(0);
    const [fileId, setFileId] = useState('');
    const [idJob, setIdJob] = useState({});
    const [getRemark, setGetRemark] = useState({});
    const [allValues, setAllValues] = useState({
        searchEmpText: '',
        job: null,
        firstName: '',
        lastName: '',
        contactNo: '',
        isReminder: false,
        reminderType: 1,
        to: null,
        date: null,
        note: '',
        resumeFiles: '',
        email: '',
        skill: [],
        tags: []
    })
    const P_S = useCallback((module, type = 'read') => _AS?.[module]?.action?.[type]?.value, [_AS]);
    const [error, setError] = useState(null);

    const [file, setFile] = useState(null);
    const [removeAttachment, setRemoveAttachment] = useState({
        removeResume: false,
        removeOtherDocuments: []
    })
    const [showReplace, setShowReplace] = useState(false);

    const forceUpdate = useForceUpdate();
    const validator = useRef(new Validator({element: (message) => <>{message}</>, autoForceUpdate: {forceUpdate}}));
    const skillField = allValues?.job?.applicationField?.fields?.find(f => f?.value === "skill");
    const tagsField = allValues?.job?.applicationField?.fields?.find(f => f?.value === "tags");

    const handle = {
        blurEve: (e, name) =>  {
            if (allValues?.job && (allValues?.email || allValues?.contactNo)) {
                // sendData('ats|candidate|getRemark', {
                //     email: allValues?.email,
                //     contactNo: allValues?.contactNo
                // })
            }
            const param = {
                job: allValues.job?._id,
            }
            if (_DC?.email && name === 'email') {
                param.email = allValues?.email
                sendData('ats|candidate|validate', param)
            } else if (_DC?.phone && name === 'contactNo') {
                param.contactNo = allValues?.contactNo
                sendData('ats|candidate|validate', param)
            } else if (_DC?.phone_and_email && allValues?.email && allValues?.contactNo) {
                if(allValues?.email) param.email = allValues?.email
                if(allValues?.contactNo) param.contactNo = allValues?.contactNo
                sendData('ats|candidate|validate', param)
            } else if (_DC?.phone_or_email) {
                if (allValues?.email) param.email = allValues?.email
                if (allValues?.contactNo) param.contactNo = allValues?.contactNo
                sendData('ats|candidate|validate', param)
            }
        },
        change: (e, name) => {
            setAllValues({...allValues, [name]: e})
            if (name === 'isReminder') {
                if (!e) {
                    handle.clear('to')
                    handle.clear('note')
                    handle.clear('date')
                }
            }
        },
        idChange: (e, key) => {
            if(key === 'candidateId') setIdJob({...idJob, [key]: e ?? null})
        },
        radio: (e, value) => {
            if (value === 1) {
                setAllValues({...allValues, reminderType: value, to: null});
            } else {
                setAllValues({...allValues, reminderType: value,});
            }
        },
        select: (e, key) => {
            if (key === 'location') setAllValues({...allValues, [key]: e?.value ?? null})
            else if (key === 'skill') {
                const newValueObj = e?.find(_ => _?.__isNew__)
                if (newValueObj) {
                    sendData(`ats|setting|skill|add`, {name: newValueObj?.value})
                } else setAllValues({...allValues, [key]: e?.map(l => l?.value) ?? []});
            } else if (key === 'tags') {
                setAllValues({...allValues, [key]: e?.map(l => l?.value) ?? []});
            }
        },
        selectJob: (e, key) => {
            const param = {
                job: e?.value
            }
            if(e?.value)sendData('ats|candidate|validate', param)
            if (_AQC?.data?.remarkByOrgId) {
                setAllValues({...allValues, [key]: e ?? null})
            } else setAllValues({...allValues, [key]: e ?? null, contactNo: '', email: ''})
        },
        addCandidate: e => {
            e.preventDefault()
            if (validator?.current?.allValid()) {
                let reminderArr = []
                setLoader(true)
                if (allValues?.to !== null) {
                    allValues?.to?.map(_ => reminderArr.push(_?._id))
                }
                const body = {
                    isReminder: allValues?.isReminder,
                    lastName: allValues?.lastName || '',
                    candidateId: idJob?.candidateId,
                    ...(allValues?.firstName && {firstName: allValues?.firstName}),
                    ...(allValues?.contactNo && {contactNo: allValues?.contactNo}),
                    ...(allValues?.email && {email: allValues?.email}),
                    ...(allValues?.reminderType && {reminderType: allValues?.reminderType}),
                    ...(allValues?.date && {date: new Date(allValues?.date).getTime()}),
                    ...(allValues?.note && {note: allValues?.note}),
                    ...(allValues?.location && {location: allValues?.location}),
                    ...(allValues?.job?.value && {job: allValues?.job?.value}),
                    ...(allValues?.skill?.length && {skill: allValues?.skill}),
                    ...(reminderArr?.length && {to: reminderArr}),
                    ...(fileId && {fileId: fileId}),
                    ...(error?.isExists && _DC.isDuplicateEnabled && {_id: error?.candidate?._id}),
                    ...(error?.isExists && _DC.isDuplicateEnabled &&  {isReplace: true}),
                    ...(allValues?.tags?.length && {tags: allValues?.tags}),
                }

                if (removeAttachment?.removeResume) body.data.removeResume = removeAttachment?.removeResume
                delete body.data?.resumeFiles

                    //  Check for duplicate and replace the button
                    if (error?.isExists && _DC?.isDuplicateEnabled && !showReplace) {
                        setShowReplace(true);
                        setLoader(false);
                        return;
                    }
                    sendData(`ats|candidate|${error?.isExists && _DC?.isDuplicateEnabled ? 'update' : 'quick-add'}`, body);
                    setShowReplace(false);

                sendData(`ats|candidate|${error?.isExists && _DC?.isDuplicateEnabled ? 'update' : 'quick-add'}`, body)
                if (_AQC?.data?.remarkByOrgId || _AQC?.data?.sharedByOrgId) {
                    sendData('ats|candidate|addToOrg', {
                        _id: _AQC?.data?.candidate,
                        addType: _AQC?.data?.addType,
                        isAddToOrgConfirm: true,
                        OrgId: _ORG_ID
                    })
                }
            } else {
                validator?.current?.showMessages();
                setLoader(false)
            }
        },
        close: e => {
            dispatch({type: 'ADD_QUICK_CANDIDATE', payload: {flag: false, data: {}}});
            setFileId('')
        },
        clear: (name) => {
            validator.current.hideMessageFor(name)
            validator.current.errorMessages[name] = undefined
            delete validator.current.errorMessages[name]
            validator.current.fields[name] = true
        },
        file: (e, name) => {
            prepareFiles({[name]: e.target.files}, name).then()
            e.target.value = '';
        },
        removeResume: e => {
            alert.show({
                title: `Delete Attachment`,
                description: `Are you sure you want to delete this Attachment?`,
                icon: <Icon.Delete fill={COLOR.u_red} size={30}/>,
                onSubmit: () => {
                    setAllValues({...allValues, resumeFiles: ''});
                    setFile(null)
                    setRemoveAttachment({
                        ...removeAttachment,
                        removeResume: true,
                    })
                }
            })
        },
    }

    /** Resume Upload */
    const prepareFiles = async (data, docsName) => {
        if (data?.[docsName]?.length <= 3) {
            let sizeError = false;
            const fileArray = Object.assign([], data?.[docsName]);

            for (let i = 0; i < fileArray.length; i++) {
                if (!sizeError) sizeError = fileArray[i].size / 1024 / 1024 > _FSL;
            }

            if (!sizeError) {
                let myFiles = [];
                const number = data?.[docsName].length;
                for (let i = 0; i < number; i++) {
                    const name = fileArray[i]?.name?.split('.');
                    const ext = name[name.length - 1];
                    if (FILE.IMAGES.exec(fileArray[i]?.name) || FILE.DOCS.exec(fileArray[i]?.name)) {
                        if (!FILE.EXCLUDES.includes(ext)) {
                            await isThisAFile(fileArray[i]).then(validFile => {
                                if (docsName === 'resumeFiles') {
                                    setAllValues({...allValues, resumeFiles: validFile});
                                    setFile(validFile)

                                    /**
                                     * Resume upload functionality
                                     * */
                                    setLoader(true)

                                    let payload = {}, fileList = {};
                                    if (validFile) {
                                        let rId = Math.random().toString(36).substr(2, 9).toString();
                                        rId = `${rId}`
                                        payload[rId] = {
                                            size: validFile.size,
                                            fileName: validFile.name,
                                            mimeType: validFile.type,
                                            lastModified: new Date().getTime()
                                        };
                                        fileList[rId] = validFile
                                    }

                                    const body = {
                                        event: 'uploadResumeFiles',
                                        data: {
                                            payload: payload,
                                            orgId: _ORG_ID,
                                            isBulkUpload: false
                                        },
                                        socketId: _SOCKET_ID
                                    }

                                    const formData = new FormData();
                                    formData.append('body', Encryption(body));
                                    for (let key in fileList) {
                                        formData.append(key, fileList[key]);
                                    }
                                    // formData.append('finish', true);
                                    const config = {
                                        headers: {'Authorization': `Bearer ${getCookie('ubs_token')}`},
                                        onUploadProgress: e => {
                                            let per = parseInt(e.loaded / e.total * 100);
                                            per = per === 100 ? 99 : per;
                                            setUploadPercentage(per)
                                        },
                                    };

                                    api2.post('/resume/upload', formData, config).then(response => { //fileUpload , hrmsFileUpload
                                        setUploadPercentage(0)
                                        // setLoader(false)
                                        // refresh();
                                    }).catch(error => {
                                        const res = error?.response
                                        if (res && res.status === 400) {
                                            setLoader(false)
                                            alert.show({
                                                title: 'Something went wrong.',
                                                description: res?.data?.err || res?.data?.error || res?.data?.message
                                            })
                                        }
                                    })
                                    /*** */

                                }
                            }).catch(error => {
                            });
                        }
                    } else {
                        alert.show({title: 'Something went wrong.', description: `Unsupported File.`})
                    }
                }
            } else {
                setFile(null);
                alert.show({title: 'Something went wrong.', description: `Files must smaller than ${_FSL}MB!`})
            }
        } else {
            alert.show({title: 'Something went wrong.', description: 'You can only upload max three files.'})
            setFile('');
        }
    };

    const isThisAFile = (maybeFile) => {
        return new Promise(function (resolve, reject) {
            if (maybeFile.type !== '') {
                return resolve(maybeFile);
            }
            const reader = new FileReader();
            reader.onloadend = () => {
                if (reader.error && reader.error.name === 'NotFoundError') {
                    return reject(reader.error.name);
                }
                resolve(maybeFile);
            };
            reader.readAsBinaryString(maybeFile);
        });
    };

    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'hrms|dropList|get':
                    if (res?.data?.listType === 4) {
                        // setEmployeeListOption(getLabelValueUserImage(res?.data?.rows));
                        setIsLoading(false);
                    }
                    break
                case 'ats|job|search':
                    setEmployeeListOption(getLabelValueUserImage(res?.data?.list?.filter(_ => _?.applicationField?.fields)));
                    setIsLoading(false);
                    break
                case 'uploadedResumeInfo':
                    setLoader(false)
                    let resData = res?.data?.data

                    let data = {
                        ...(allValues?.contactNo === '' && {contactNo: resData?.contactNo?.replace(" ", "") || ''}),
                        ...(allValues?.email === '' && {email: resData?.email}),
                        ...(allValues?.firstName === '' && {firstName: resData?.firstName}),
                        ...(allValues?.lastName === '' && {lastName: resData?.lastName}),
                        ...(allValues?.skill?.length === 0 && {skill: resData?.skill}),
                        ...(allValues?.tags?.length === 0 && {tags: resData?.tags}),
                    }
                    setAllValues({...allValues, ...data});
                    setFileId(res?.data?.fileId)
                    break
                case 'ats|setting|skill|add':
                    setAllValues({...allValues, skill: [...allValues?.skill, res?.data?.skillInfo?._id]})
                    break;
                case 'ats|candidate|validate':
                    setError(res?.data)
                    break;
                case 'ats|candidate|update':
                    dispatch({type: 'ADD_QUICK_CANDIDATE', payload: {flag: false, data: {}}});
                    break;
                case 'ats|candidate|fetchId':
                    const datas = {
                        candidateIdType: res?.data?.candidateIdType,
                        ...(res?.data?.candidateIdType === 2 && {candidateId: res?.data?.candidateId ?? ''}),
                        ...(res?.data?.candidateIdType === 1 && {lastId: res?.data?.candidateId ?? ''})
                    }
                    setIdJob(prev => ({...prev, ...datas}))
                    break;
                case 'ats|candidate|getRemark':
                    setGetRemark(res?.data?.getRemarks)
                    break;
                case 'ats|candidate|addToOrg':
                    setAllValues({...allValues,
                        firstName: res?.data?.firstName || '',
                        lastName: res?.data?.lastName || '',
                        email: res?.data?.email || '',
                        contactNo: res?.data?.contactNo,
                    })
                    break;
                default:
                    return true;
            }
        } else {
            switch (res.code) {
                case 400: {
                    switch (res.event) {
                        case 'uploadedResumeInfo': {
                            setLoader(false)
                            break;
                        }
                        case 'ats|candidate|add': {
                            setLoader(false)
                            break;
                        }
                        default:
                            break;
                    }
                    break
                }
                case 409: {
                    switch (res.event) {
                        case 'ats|candidate|quick-add': {
                            setLoader(false)
                            break;
                        }
                        default:
                            break;
                    }
                    break
                }
                default:
                    break;
            }
        }
    });


    useEffect(() => {
        refresh();
        return () => off();
    }, [allValues]);

    useEffect(() => {
        sendData('ats|candidate|fetchId', {})
    }, []);


    const searchEmployee = value => {
        setAllValues({...allValues, searchEmpText: value});
        if (value?.length) setIsLoading(true);
    }

    useDebouncedEffect(() => {
        if (allValues?.searchEmpText?.length >= LIMIT.SEARCH_CHARACTER) sendData('ats|job|search', {listType: 4, search: allValues?.searchEmpText})
        else setEmployeeListOption([]);
    }, LIMIT.DE_BOUNCING_TIME_OUT, [allValues?.searchEmpText]);

    return (
        <React.Fragment>
            <UModal
                open={true}
                maxWidth={getRemark?.length ? 1200 : 600}
                header={<h4>Quick Add Candidate</h4>}
                onClose={() => handle.close()}
            >
                <div className={getRemark?.length && 'u_flex'}>
                    <div className="u_p-15 u_w-full">
                    <div className="u_row">
                        <div className="u_col-12 u_mb-15">
                            <UInput label="Search Job Opening" select selectValue={allValues?.job} asterisk hasError={validator.current.message('job', allValues?.job, 'required')}>
                                <Select
                                    name="job"
                                    className="u_input-select-inner"
                                    classNamePrefix="u_select"
                                    placeholder=" "
                                    isClearable={true}
                                    value={allValues?.job ?? null}
                                    onInputChange={searchEmployee}
                                    onChange={e => handle.selectJob(e, 'job')}
                                    options={employeeListOption}
                                    noOptionsMessage={() => allValues?.searchEmpText?.length < 3 ? 'Type three character to search job name.' : isLoading ? 'Loading...' : 'No Record Found'}
                                    menuPosition="fixed"
                                    onKeyDown={e => {
                                        if ((e.keyCode === 32 || e.keyCode === 8 || e.keyCode === 9) && !e.target.value) e.preventDefault();
                                    }}
                                    components={{
                                        Option: (props) => (
                                            <components.Option {...props}>
                                                <div className="u_filter-employee-info">
                                                    <UAvatar name={props?.data?.label} width={24} thumbor={getThumbor('32x32')}
                                                             image={props?.data?.profileImage} s3Url={_S3_BASE_URL}/>
                                                    <div className="u_flex u_direction-column">
                                                    <p className="u_one-line">{props?.data?.label}</p>
                                                    {props?.data?.jobId &&
                                                        <p className="u_color-font u_one-line u_ml-10">{props?.data?.jobId}</p>}
                                                    </div>
                                                </div>
                                            </components.Option>
                                        ),
                                        SingleValue: (props) => (
                                            <components.SingleValue {...props}>
                                                <div className="u_filter-employee-info">
                                                    <UAvatar name={props?.data?.label} width={24} thumbor={getThumbor('32x32')}
                                                             image={props?.data?.profileImage} s3Url={_S3_BASE_URL}/>
                                                    <div className="u_flex u_direction-column u_content-center">
                                                    <p className="u_one-line">{props?.data?.label}</p>
                                                    {props?.data?.jobId &&
                                                        <p className="u_color-font u_one-line u_ml-10">{props?.data?.jobId}</p>}
                                                    </div>
                                                </div>
                                            </components.SingleValue>
                                        ),
                                    }}
                                />
                            </UInput>
                        </div>
                    
                    </div>
                    {/** single file upload */}
                    <div className="u_row">
                        {<div className="u_col-12 u_mb-15">
                            {!allValues?.resumeFiles ? <div
                                className={`u_upload-file u_relative u_p-15 u_flex u_align-center u_content-center u_t-center u_flex-col`}
                                style={{minHeight: '110px'}}>
                                <label className="u_upload-file-label">
                                    <input type="file" className="img_file_input" accept="image/*, .doc, .pdf" name="resumeFiles" id="resumeFiles"
                                           onChange={e => handle.file(e, 'resumeFiles')}
                                           autoComplete="off"/>
                                </label>
                                <div
                                    className="u_upload-file-inner u_flex u_align-center u_content-center u_t-center u_flex-col">
                                    <Icon.Upload size={22} fill={COLOR.u_blue}/>
                                    <p className="u_mt-5 u_small-font u_color-blue">Upload Resume</p>
                                </div>
                            </div> : <div className="u_file-docs">
                                <div className="u_file-info" style={{minHeight: `110px`}}>
                                    <div className="u_file-info-icon">
                                        <span className="u_m-auto u_text-center">
                                            <Icon.FilePreview fill={COLOR.u_blue} size={18}/>
                                            <span
                                                className="u_font">{getExtension((allValues?.resumeFiles?.name || allValues?.resumeFiles?.fileName)) ?? '-'}</span>
                                        </span>
                                    </div>
                                    <div className="u_file-info-content">
                                        <p className="u_file-name u_one-line u_mb-5">{(allValues?.resumeFiles?.name || allValues?.resumeFiles?.fileName) || '-'}</p>
                                        <div className="u_flex u_align-center">
                                            <p className="u_small-font u_mr-10">{allValues?.resumeFiles?.size ? bytesToSize(allValues?.resumeFiles?.size) : 0}</p>
                                            <UTags title='Resume' color={COLOR.u_green}/>
                                        </div>
                                    </div>
                                    <div className="u_file-info-action">
                                        <UPopup params={{className: "u_tooltip u_tooltip-full", on: ['hover']}}
                                                desc={<span className='u_text-c'>Delete</span>}>
                                            <span className="u_cp u_mx-5" onClick={() => handle.removeResume()}>
                                                <Icon.Delete size={16} fill={COLOR.u_blue}/>
                                            </span>
                                        </UPopup>
                                    </div>
                                </div>
                            </div>}
                        </div>}
                    </div>
                    <div className="u_row">
                        {allValues?.job && allValues?.job?.applicationField?.fields.find(_ => (_.value === "candidateId" && _.status !== 3)) && <div className="u_col-6 u_mb-20">
                            <UInput label={getLabel(PROFILE_SECTION.basicInfo, 'candidateId', 'Candidate ID')} asterisk={allValues?.job?.applicationField?.fields.find(_ => (_.value === "candidateId" && _.status === 1))} notice note={`Last ${getLabel(PROFILE_SECTION.basicInfo, 'candidateId', 'Candidate ID')} is: ${idJob?.lastId}`}
                                    className={idJob?.candidateIdType === 2 ? 'u_btn__disabled' : ''}
                                    hasError={allValues?.job?.applicationField?.fields.find(_ => (_.value === "candidateId" && _.status === 1)) && validator?.current?.message('candidateId', idJob?.candidateId, `required|between:1,100,string`)}>
                                <input
                                    type="text"
                                    placeholder=" "
                                    name="candidateId"
                                    value={idJob?.candidateId}
                                    onChange={(e) => handle.idChange(e?.target?.value?.toUpperCase(), 'candidateId')}
                                    autoComplete="off"
                                />
                            </UInput>
                        </div>}
                        <div className="u_col-6 u_mb-15">
                            <UInput label={getLabel(PROFILE_SECTION.basicInfo, 'firstName', 'First Name')} asterisk hasError={validator.current.message('firstName', allValues?.firstName, 'required')}>
                                <input type="text" name="firstName" placeholder=" " value={allValues?.firstName}
                                       autoComplete="off" onChange={e => handle.change(e?.target?.value, 'firstName')}/>
                            </UInput>
                        </div>
                        <div className="u_col-6 u_mb-15">
                            <UInput label={getLabel(PROFILE_SECTION.basicInfo, 'lastName', 'Last Name')}>
                                <input type="text" name="lastName" placeholder=" " value={allValues?.lastName}
                                       autoComplete="off" onChange={e => handle.change(e?.target?.value, 'lastName')}/>
                            </UInput>
                        </div>
                    </div>
                    <div className="u_row">
                        <div className="u_col-6 u_mb-15">
                            <UInput label="Contact Number"  hasError={validator.current.message('contactNo', allValues?.contactNo, 'min:10|max:12')}>
                                <input type="number" name="contactNo" placeholder=" " value={allValues?.contactNo}
                                       onKeyDown={e => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                       autoComplete="off" onChange={e => handle.change(e?.target?.value, 'contactNo')}
                                       onBlur={e => handle.blurEve(e?.target?.value, 'contactNo')}/>
                            </UInput>
                            {error?.contactNoErr &&
                                <p className="u_color-red u_small-font u_mt-5">{error?.contactNoErr}</p>
                            }
                        </div>
                        <div className="u_col-6 u_mb-15">
                            <UInput label={getLabel(PROFILE_SECTION.jobInfo, 'location', 'Location')} select selectValue={allValues?.location}>
                                <Select
                                    name="location"
                                    className="u_label-input-select-inner"
                                    classNamePrefix="u_select"
                                    placeholder=" "
                                    value={getKeyName(_A_LT, allValues?.location) ?? null}
                                    onChange={e => handle.select(e, 'location')}
                                    options={_A_LT?.filter((_ => _.isActive && !_.isDeleted))}
                                    noOptionsMessage={() => 'No location found'}
                                    menuPosition="fixed"
                                    maxMenuHeight={150}
                                    onKeyDown={e => {
                                        if ((e.keyCode === 32 || e.keyCode === 8 || e.keyCode === 9) && !e.target.value) e.preventDefault();
                                    }}
                                />
                            </UInput>
                        </div>
                    </div>
                    <div className="u_row">
                        <div className="u_col-6 u_mb-15">
                            <UInput label={`${getLabel(PROFILE_SECTION.emergencyContact, 'email', 'Email')}`}
                                    hasError={validator?.current?.message('email', allValues?.email, 'required|email')}>
                                <input
                                    type="text"
                                    placeholder=" "
                                    name="email"
                                    value={allValues?.email}
                                    onChange={(e) => handle.change(e?.target?.value, 'email')}
                                    autoComplete="off"
                                    onBlur={e => handle.blurEve(e?.target?.value, 'email')}
                                    style={{ textTransform: 'lowercase' }}
                                />
                            </UInput>
                            {error?.emailErr &&
                                <p className="u_color-red u_small-font u_mt-5">{error?.emailErr}</p>
                            }
                        </div>
                        {skillField?.status !== 3 &&
                        <div className="u_col-6 u_mb-15">
                            <UInput label="Skill" select selectValue={allValues?.skill?.length ? allValues?.skill[0] : null} asterisk={skillField?.status === 1}  hasError={skillField?.status === 1 && validator.current.message('skill', allValues?.skill, 'required')}>
                                <CreatableSelect
                                    name="skill"
                                    classNamePrefix="u_select"
                                    className="u_input-select-inner u_multi-select-user u_menu-scroll"
                                    placeholder=" "
                                    value={_ASL?.filter(l => allValues?.skill?.find(a => a === l?.value)) ?? null}
                                    onChange={e => handle.select(e, 'skill')}
                                    options={_ASL}
                                    noOptionsMessage={() => P_S('skill', 'create') ? 'Type & Create New Skill' : 'No Skill Found'}
                                    isValidNewOption={value => value?.length && !searchInArray(value?.trim(), _ASL, 'name')?.length ? P_S('skill', 'create') : false}
                                    isMulti={true}
                                    menuPosition="fixed"
                                    maxMenuHeight={150}
                                    formatCreateLabel={props => <React.Fragment {...props}>
                                        <div
                                            className="u_flex u_align-center u_content-between u_create-activity-inner">
                                            <p className="u_create-activity-label u_task-darkname u_fw-normal">Create New Skill <strong
                                                className="u_word-breakall">"{props}"</strong>
                                            </p>
                                            <span className="u_create-activity-btn u_cp">
                                                <Icon.Plus size={16} fill={COLOR.u_white} className="u_m-auto"/>
                                            </span>
                                        </div>
                                    </React.Fragment>}
                                    components={{
                                        MultiValue: (props) => (
                                            <components.MultiValue {...props}>
                                                <p className="u_one-line">{props?.data?.label}</p>
                                            </components.MultiValue>
                                        ),
                                    }}
                                />
                            </UInput>
                        </div>}
                    </div>
                        <div className="u_row">
                            {tagsField?.status !== 3 &&
                            <div className="u_col-6 u_mb-15">
                                <UInput label="Tag" select selectValue={allValues?.tags?.length ? allValues?.tags[0] : null} asterisk={tagsField?.status === 1}  hasError={tagsField?.status === 1 && validator.current.message('tags', allValues?.tags, 'required')}>
                                    <CreatableSelect
                                        name="tags"
                                        classNamePrefix="u_select"
                                        className="u_input-select-inner u_multi-select-user u_menu-scroll"
                                        placeholder=" "
                                        value={_TF_CL?.filter(l => allValues?.tags?.find(a => a === l?.value)) ?? null}
                                        onChange={e => handle.select(e, 'tags')}
                                        options={_TF_CL}
                                        noOptionsMessage={() => P_S('tags', 'create') ? 'Type & Create New Tag' : 'No Tag Found'}
                                        isValidNewOption={value => value?.length && !searchInArray(value?.trim(), _TF_CL, 'name')?.length ? P_S('tags', 'create') : false}
                                        isMulti={true}
                                        menuPosition="fixed"
                                        maxMenuHeight={150}
                                        formatCreateLabel={props => <React.Fragment {...props}>
                                            <div
                                                className="u_flex u_align-center u_content-between u_create-activity-inner">
                                                <p className="u_create-activity-label u_task-darkname u_fw-normal">Create New Tag <strong
                                                    className="u_word-breakall">"{props}"</strong>
                                                </p>
                                                <span className="u_create-activity-btn u_cp">
                                                <Icon.Plus size={16} fill={COLOR.u_white} className="u_m-auto"/>
                                            </span>
                                            </div>
                                        </React.Fragment>}
                                        components={{
                                            MultiValue: (props) => (
                                                <components.MultiValue {...props}>
                                                    <p className="u_one-line">{props?.data?.label}</p>
                                                </components.MultiValue>
                                            ),
                                        }}
                                    />
                                </UInput>
                            </div>}
                        </div>
                    <div className="u_row">
                        <div className="u_col-12 u_mb-15">
                            <UCheckBox
                                id={`isReminder`}
                                label="Wanted to set a reminder?"
                                name="isReminder"
                                className="u_mr-10 u_ib u_cp"
                                checked={allValues?.isReminder}
                                onChange={e => handle.change(e?.target?.checked, 'isReminder')}
                                htmlFor="isReminder"
                            />
                        </div>

                        {allValues?.isReminder && <React.Fragment>
                            <div className="u_col-12 u_mb-15">
                                <URadio
                                    id="reminder-me"
                                    name="reminderType"
                                    label="Reminder to me"
                                    htmlFor="reminder-me"
                                    onChange={e => handle.radio(e, 1)}
                                    checked={allValues?.reminderType === 1}
                                />
                            </div>

                            <div className="u_col-12 u_mb-15">
                                <URadio
                                    id="reminder-person"
                                    name="reminderType"
                                    label="Reminder to selected person"
                                    htmlFor="reminder-person"
                                    onChange={e => handle.radio(e, 2)}
                                    checked={allValues?.reminderType === 2}
                                />
                            </div>
                        </React.Fragment>}
                    </div>
                    {(allValues?.reminderType === 2 && allValues?.isReminder) && <div className="u_row">
                        <div className="u_col-12 u_mb-15">
                            <UInput label="Reminder to" select asterisk selectValue={allValues?.to} hasError={validator.current.message('to', allValues?.to, 'required')}>
                                <AsyncEmployeeSelect
                                    value={allValues?.to}
                                    onChange={(e) => handle.change(e, 'to')}
                                    params={{isMulti: true, menuPlacement: 'auto'}}
                                />
                            </UInput>
                        </div>
                    </div>}
                    {allValues?.isReminder && <div className="u_row">
                        <div className="u_col-12 u_mb-15">
                            <UInput label={'Select Date & Time'} datepicker asterisk
                                    selectDate={allValues?.date}
                                    hasError={validator.current.message('date', allValues?.date, 'required')}
                                    className="u_datetime-picker">
                                <UDatePicker
                                    selected={allValues?.date ? new Date(allValues?.date) : null}
                                    onChange={(e) => handle.change(e, 'date')}
                                    dateFormat="dd/MM/yy h:mm aa"
                                    timeIntervals={10}
                                    name="date"
                                    placeholderText=" "
                                    popperPlacement="bottom-start"
                                    showTimeSelect
                                />
                            </UInput>
                        </div>
                    </div>}
                    {allValues?.isReminder && <div className="u_row">
                        <div className="u_col-12 u_mb-15">
                            <UInput label="Add Note" textarea asterisk hasError={validator?.current?.message("note", allValues?.note, "required|max:500,string")}>
                                <textarea
                                    className={`u_textarea u_textarea-six-rows`}
                                    placeholder=" "
                                    name="note"
                                    value={allValues?.note}
                                    autoComplete="off"
                                    maxLength={500}
                                    onChange={(e) => handle.change(e?.target?.value, 'note')}
                                />
                            </UInput>
                        </div>
                    </div>}
                

                </div>
                    {!!getRemark?.length && (allValues?.contactNo !== '' || allValues?.email !== '') && <div className="u_p-15 u_w-full u_remarks">
                        <span className="u_ib u_mb-10">
                            <UTags
                                className="u_flex-align u_flex-row-reverse"
                                icon={<Icon.UserStar size={16} fill={COLOR.u_purple}/>}
                                title={`This candidate received ${getRemark?.length} Remarks`}
                                color={COLOR.u_purple}
                                length={1500}
                            />
                        </span>
                        {getRemark.map(data => {
                            return (<div className="u_remarks-inner u_mb-10">
                                <div className="u_flex-align u_content-between u_px-15 u_py-12">
                                    <div className="u_flex-align">
                                        <p className="u_one-line u_mr-15">{data?.remarkByOrg}</p>
                                        {data?.remarkByOrgId === _ORG_ID && <UTags title={`You have given`} color={COLOR.u_orange} className="u_flex-shrink u_mr-5"/>}
                                    </div>
                                    <span className="u_flex-shrink"><UDateFormatter date={data?.updatedAt} format={'ddd, MMMM D, YYYY'}/></span>
                                </div>

                                <h3>{data?.remarkReason}</h3>
                            </div>)
                        })}
                    </div>}
                </div>
                <div className="u_modal-buttons">
                    {error?.isExists && _DC?.isDuplicateEnabled ? <><UButton disabled={loader} loading={loader} variant="white" cn="u_mr-10" type="Cancel" onClick={() => handle?.close()}/>
                    <UButton disabled={loader} loading={loader} variant="blue" type="Replace" onClick={handle.addCandidate}/></>
                    :
                    <><UButton disabled={loader} loading={loader} variant="white" type="Cancel" onClick={(e) => handle.close()}/>
                    <UButton disabled={loader} loading={loader} isSubmit variant="blue" type="Save" cn="u_ml-10" onClick={handle.addCandidate}/></>
                    }
                </div>
            </UModal>
        </React.Fragment>
    );
});

export default AddQuickCandidate;
